import favicon from "./favicon.png";

export default {
  favicon: favicon,
  title: "Cashdesk"
};



// WEBPACK FOOTER //
// ./src/assets/head/mhi/index.js